import {
    DISPLAY_ALERT,
    CLEAR_ALERT,
    LOGOUT_USER_BEGIN,
    LOGOUT_USER_SUCCESS,
    CREATE_COMPANY_BEGIN,
    CREATE_COMPANY_SUCCESS,
    CREATE_COMPANY_ERROR,
    SWITCH_COMPANY_BEGIN,
    SWITCH_COMPANY_SUCCESS,
    SWITCH_COMPANY_ERROR,
    SWITCH_COMPANY_TO_PROFILE_BEGIN,
    SWITCH_COMPANY_TO_PROFILE_SUCCESS,
    SWITCH_COMPANY_TO_PROFILE_ERROR,
    SWITCH_UNCLAIMED_PROFILE_BEGIN,
    SWITCH_UNCLAIMED_PROFILE_SUCCESS,
    SWITCH_UNCLAIMED_PROFILE_ERROR,
    LOGOUT_COMPANY
} from './actions';

import { initialState } from './appContext';

const reducer = (state, action) => {
    if (action.type === DISPLAY_ALERT) {
        return {
            ...state,
            showAlert: true,
            alertType: action.severity,
            alertSummary: action.summary,
            alertDetail: action.detail,
            alertLife: action.life,
            alertSticky: action.sticky,
            isProcessing: false
        };
    }
    if (action.type === CLEAR_ALERT) {
        return { ...state, showAlert: false, alertType: '', alertText: '' };
    }
    if (action.type === LOGOUT_USER_BEGIN) {
        return {
            ...state,
            isProcessing: true
        };
    }
    if (action.type === LOGOUT_USER_SUCCESS) {
        return {
            ...initialState,
            userName: '',
            companyName: '',
            isProcessing: false
        };
    }
    if (action.type === CREATE_COMPANY_BEGIN) {
        return {
            ...state,
            isProcessing: true
        };
    }
    if (action.type === CREATE_COMPANY_SUCCESS) {
        return {
            ...state,
            companyName: action.companyName,
            isProcessing: false
        };
    }
    if (action.type === CREATE_COMPANY_ERROR) {
        return {
            ...state,
            isProcessing: false
        };
    }
    if (action.type === SWITCH_COMPANY_BEGIN) {
        return {
            ...state,
            isProcessing: true
        };
    }
    if (action.type === SWITCH_COMPANY_SUCCESS) {
        return {
            ...state,
            companyName: action.companyName,
            isProcessing: false
        };
    }
    if (action.type === SWITCH_COMPANY_ERROR) {
        return {
            ...state,
            isProcessing: false
        };
    }
    if (action.type === SWITCH_COMPANY_TO_PROFILE_BEGIN) {
        return {
            ...state,
            isProcessing: true
        };
    }
    if (action.type === SWITCH_COMPANY_TO_PROFILE_SUCCESS) {
        return {
            ...state,
            companyName: action.companyName,
            isProcessing: false
        };
    }
    if (action.type === SWITCH_COMPANY_TO_PROFILE_ERROR) {
        return {
            ...state,
            isProcessing: false
        };
    }
    if (action.type === SWITCH_UNCLAIMED_PROFILE_BEGIN) {
        return {
            ...state,
            isProcessing: true
        };
    }
    if (action.type === SWITCH_UNCLAIMED_PROFILE_SUCCESS) {
        return {
            ...state,
            companyName: action.companyName,
            isProcessing: false
        };
    }
    if (action.type === SWITCH_UNCLAIMED_PROFILE_ERROR) {
        return {
            ...state,
            isProcessing: false
        };
    }
    if (action.type === LOGOUT_COMPANY) {
        return {
            ...state,
            isProcessing: false,
            companyName: ''
        };
    }

    throw new Error(`No such action: ${action.type}`);
};
export default reducer;
